var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"form-control",attrs:{"type":"text","required":_vm.required},domProps:{"value":_vm.handler},on:{"input":_vm.mask}})}
var staticRenderFns = []

export { render, staticRenderFns }